export const ROUTES = {
    BRIEF_LOGO_NAME: 'logo_name',
    BRIEF_LOGO_STYLE: 'logo_style',
    BRIEF_BRAND_INDUSTRY: 'brand_industry',
    BRIEF_BRAND_PERSONALITY: 'brand_personality',
};

export const STEPS = [
    ROUTES.BRIEF_LOGO_NAME,
    ROUTES.BRIEF_BRAND_INDUSTRY,
    ROUTES.BRIEF_LOGO_STYLE,
    ROUTES.BRIEF_BRAND_PERSONALITY,
];

export const SAMPLE_PAIR_SIZE = 2;
export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_ROUTE = ROUTES.BRIEF_LOGO_NAME;
export const BRIEF_PAGE_BODY_CLASS = 'buyers-brief-page';
export const BRIEF_LOADING_PAGE_BODY_CLASS = 'buyers-loading-brief-page';
